"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/forbid-prop-types */
var react_1 = require("react");
var prop_types_1 = __importDefault(require("prop-types"));
var get_context_props_1 = __importDefault(require("./get-context-props"));
var cache_1 = __importDefault(require("./cache"));
var childContextCache = new cache_1.default();
/**
 * ConfigProvider
 * @propsExtends false
 */
var ConfigProvider = /** @class */ (function (_super) {
    __extends(ConfigProvider, _super);
    function ConfigProvider() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        childContextCache.add(_this, Object.assign({}, childContextCache.get(_this, {}), _this.getChildContext()));
        _this.state = {
            locale: _this.props.locale,
        };
        return _this;
    }
    ConfigProvider.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) {
            return {
                locale: nextProps.locale,
            };
        }
        return null;
    };
    ConfigProvider.prototype.getChildContext = function () {
        var _a = this.props, prefix = _a.prefix, locale = _a.locale, defaultPropsConfig = _a.defaultPropsConfig, pure = _a.pure, warning = _a.warning, rtl = _a.rtl, device = _a.device, popupContainer = _a.popupContainer, errorBoundary = _a.errorBoundary;
        var _b = this.context, nextPrefix = _b.nextPrefix, nextDefaultPropsConfig = _b.nextDefaultPropsConfig, nextLocale = _b.nextLocale, nextPure = _b.nextPure, nextRtl = _b.nextRtl, nextWarning = _b.nextWarning, nextDevice = _b.nextDevice, nextPopupContainer = _b.nextPopupContainer, nextErrorBoundary = _b.nextErrorBoundary;
        return {
            nextPrefix: prefix || nextPrefix,
            nextDefaultPropsConfig: defaultPropsConfig || nextDefaultPropsConfig,
            nextLocale: locale || nextLocale,
            nextPure: typeof pure === "boolean" ? pure : nextPure,
            nextRtl: typeof rtl === "boolean" ? rtl : nextRtl,
            nextWarning: typeof warning === "boolean" ? warning : nextWarning,
            nextDevice: device || nextDevice,
            nextPopupContainer: popupContainer || nextPopupContainer,
            nextErrorBoundary: errorBoundary || nextErrorBoundary,
        };
    };
    ConfigProvider.prototype.componentDidUpdate = function () {
        childContextCache.add(this, Object.assign({}, childContextCache.get(this, {}), this.getChildContext()));
    };
    ConfigProvider.prototype.componentWillUnmount = function () {
        childContextCache.remove(this);
    };
    ConfigProvider.prototype.render = function () {
        return react_1.Children.only(this.props.children);
    };
    ConfigProvider.defaultProps = {
        warning: true,
        errorBoundary: false,
    };
    ConfigProvider.contextTypes = {
        nextPrefix: prop_types_1.default.string,
        nextLocale: prop_types_1.default.object,
        nextDefaultPropsConfig: prop_types_1.default.object,
        nextPure: prop_types_1.default.bool,
        nextRtl: prop_types_1.default.bool,
        nextWarning: prop_types_1.default.bool,
        nextDevice: prop_types_1.default.oneOf(["tablet", "desktop", "phone"]),
        nextPopupContainer: prop_types_1.default.any,
        nextErrorBoundary: prop_types_1.default.oneOfType([prop_types_1.default.bool, prop_types_1.default.object]),
    };
    ConfigProvider.childContextTypes = {
        nextPrefix: prop_types_1.default.string,
        nextLocale: prop_types_1.default.object,
        nextDefaultPropsConfig: prop_types_1.default.object,
        nextPure: prop_types_1.default.bool,
        nextRtl: prop_types_1.default.bool,
        nextWarning: prop_types_1.default.bool,
        nextDevice: prop_types_1.default.oneOf(["tablet", "desktop", "phone"]),
        nextPopupContainer: prop_types_1.default.any,
        nextErrorBoundary: prop_types_1.default.oneOfType([prop_types_1.default.bool, prop_types_1.default.object]),
    };
    /**
     * 传入组件的 props 和 displayName，得到和 childContext 计算过的包含有 preifx/locale/pure 的对象，一般用于通过静态方法生成脱离组件树的组件
     * @param {Object} props 组件的 props
     * @param {String} displayName 组件的 displayName
     * @returns {Object} 新的 context props
     */
    ConfigProvider.getContextProps = function (props, displayName) {
        return (0, get_context_props_1.default)(props, childContextCache.root() || {}, displayName);
    };
    ConfigProvider.clearCache = function () {
        childContextCache.clear();
    };
    ConfigProvider.getContext = function () {
        var _a = childContextCache.root() || {}, nextPrefix = _a.nextPrefix, nextLocale = _a.nextLocale, nextDefaultPropsConfig = _a.nextDefaultPropsConfig, nextPure = _a.nextPure, nextRtl = _a.nextRtl, nextWarning = _a.nextWarning, nextDevice = _a.nextDevice, nextPopupContainer = _a.nextPopupContainer, nextErrorBoundary = _a.nextErrorBoundary;
        return {
            prefix: nextPrefix,
            locale: nextLocale,
            defaultPropsConfig: nextDefaultPropsConfig,
            pure: nextPure,
            rtl: nextRtl,
            warning: nextWarning,
            device: nextDevice,
            popupContainer: nextPopupContainer,
            errorBoundary: nextErrorBoundary,
        };
    };
    return ConfigProvider;
}(react_1.Component));
// export default polyfill(ConfigProvider);
exports.default = ConfigProvider;
